import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BaseLayout from "../../components/BaseLayout";
import { Row, Col, Button } from "react-bootstrap";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import TopNavigation from "../../components/TopNavigation";
import { dateFormater, priceDecimal } from "../../utils/utilities";
import "./style.scss";
import { connect } from "react-redux";
import { defaultSocialMedias } from "../../components/ButtonImage";
import ApiUtils from "../../utils/api_utils";

const HeaderContent = ({
  first_name,
  last_name,
  join_date,
  short_bio,
  image,
}) => (
  <div className="content-header">
    <TopNavigation
      titlePage=""
      toPath={PageRoutes.home}
      setBorder={false}
      showRightIcon={true}
      iconLeft={Assets.iconBackWhite}
      iconRight={Assets.iconSetting}
      rightEvent={true}
      rightEventPath={PageRoutes.setting}
    />
    <Row className="account-section">
      <Col xs={9} sm={9} md={9} className="account-info">
        <div className="account-name">{`${first_name} ${last_name}`}</div>
        <div>{`Joined on ${dateFormater(join_date)}`}</div>
      </Col>
      <Col xs={3} sm={3} md={3}>
        {image ? (
          <img
            src={ApiUtils.validateImgUrl({ url: image })}
            className="account-img"
            alt="picture"
          />
        ) : (
          <img
            src={Assets.iconProfile}
            className="account-img"
            alt="placeholder"
          />
        )}
      </Col>
    </Row>
    <Row className="account-bio">
      <Col xs={8} sm={8} md={8}>
        {short_bio ? <p>{short_bio}</p> : <p></p>}
      </Col>
    </Row>
  </div>
);

const AccountPage = (props) => {
  const navigate = useNavigate();
  const { profile, star_summary, pwa_setting, getTotal } = props;
  const { current_tier } = star_summary;
  const [totalPoint, setTotalPoint] = useState(0);

  useEffect(() => {
    getTotal()
      .then((response) => {
        setTotalPoint(response.data.points.value);
      })
      .catch((error) => {
        setTotalPoint(0);
      });
  }, []);

  return (
    <BaseLayout
      show_menu={pwa_setting.show_main_menu}
      bottomNavIndex={4}
      header={
        <HeaderContent
          first_name={profile.first_name}
          last_name={profile.last_name}
          join_date={profile.date_employed}
          short_bio={profile.short_bio}
          image={profile.profile_pic_url}
        />
      }
    >
      <div className="account-content">
        <Row>
          <Col>
            <div>Current Point</div>
            <div className="point-info">
              <img
                src={Assets.iconOval}
                className="point-img"
                alt="coin_image"
              />
              {priceDecimal(totalPoint)} Pts
            </div>
            <div>{`Point will expire on ${
              profile.point_expiry_date
                ? dateFormater(profile.point_expiry_date)
                : ""
            }`}</div>
          </Col>
        </Row>
        <Row className="badge-status">
          <Col className="account-level">
            <Row>
              <Col xs={4} sm={4} md={4}>
                <img
                  src={
                    current_tier
                      ? ApiUtils.validateImgUrl({ url: current_tier.img })
                      : Assets.iconBadge
                  }
                  alt="content_item_badge"
                  className="badge-img"
                />
              </Col>
              <Col xs={8} sm={8} md={8}>
                <div>Current Level</div>
                <div className="badge-lbl">
                  {current_tier ? current_tier.tier_name : "-"}
                </div>
              </Col>
            </Row>
          </Col>
          <Col className="account-star">
            <div>Current Stars</div>
            <Row className="badge-lbl">
              <Col xs={2} sm={2} md={2}>
                <img
                  src={Assets.iconStar}
                  alt="content_item_star"
                  className="badge-img-star"
                />
              </Col>
              <Col xs={10} sm={10} md={10}>
                {priceDecimal(star_summary.total_stars)}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="account-button">
          <Button
            className="border-0"
            onClick={() => navigate(PageRoutes.showMyCard)}
          >
            <Row>
              <Col xs={2} sm={2} md={2}>
                <img src={Assets.iconIdcard} alt="card_item_image" />
              </Col>
              <Col xs={8} sm={8} md={8}>
                Show My Card
              </Col>
            </Row>
          </Button>
          <Button
            className="border-0"
            onClick={() => navigate(PageRoutes.showMyQrCode)}
          >
            <Row>
              <Col xs={2} sm={2} md={2}>
                <img src={Assets.iconQrcode} alt="card_item_image" />
              </Col>
              <Col xs={8} sm={8} md={8}>
                Show My QR Code
              </Col>
            </Row>
          </Button>
        </Row>
        {defaultSocialMedias({ profile })}
      </div>
    </BaseLayout>
  );
};

const mapStateToProps = (state) => ({
  point_summary: state.FinanceSM.pointSummaryData,
  star_summary: state.FinanceSM.starSummaryData,
  profile: state.ProfileSM.profile,
  pwa_setting: state.LoginSM.login.organization_pwa_settings,
});

const mapDispatchToProps = (dispatch) => ({
  getTotal: dispatch.FinanceSM.getTotal,
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountPage);
